module.exports = __webpack_public_path__ + "img/sombra1-700x840.e81eca5b.jpg";